export enum Routes {
  Root = "/",
  SignIn = "/sign-in",
  BookingById = '/booking/:id',
  BookingDetails = '/booking-details/:id',
  CheckIn = '/check-in',
  Spending = '/spending',
  Clients = '/clients',
  Statistics = '/statistics',
  Reports = '/reports',
  Bonuses = '/bonuses'
}
